/**
 * カラーパレットの共通処理をまとめます.
 *
 */
import colorJson from "@/assets/color-palette.json";

const ColorUtils = {
  convertJsonToColorObject() {
    const colors = [];
    // JSONを読み込む
    const colorData = colorJson;
    // JSONのpalette以下をcolorsに入れる
    for (const color of colorData.palette) {
      const colorAccent = 'rgba(' + color.accent.r + ',' + color.accent.g + ',' + color.accent.b + ',' + color.accent.a + ')';
      const colorBase = 'rgba(' + color.base.r + ',' + color.base.g + ',' + color.base.b + ',' + color.base.a + ')';
      const colorBg = 'rgba(' + color.bg.r + ',' + color.bg.g + ',' + color.bg.b + ',' + color.bg.a + ')';
      const colorRgb = { 'id': color.id, 'accent': colorAccent, 'base': colorBase, 'bg': colorBg };
      colors.push(colorRgb);
    }
    return colors;
  }
};
export default ColorUtils;
